import { render, staticRenderFns } from "./majorPollution.vue?vue&type=template&id=9eccf39a&"
import script from "./majorPollution.vue?vue&type=script&lang=js&"
export * from "./majorPollution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports